import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BULK_EXPORT_META_DATA } from '@reporting/views/bulk-export/bulk-export-config';
import { AuthService } from 'app/services/index';
import { saveAs } from 'file-saver';
import { BulkExportMetaData } from '../../interfaces/bulk-export-meta-data';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class BulkExportEntityService {
    readonly importMetaData = BULK_EXPORT_META_DATA;

    private _entity: BulkExportMetaData;

    constructor(
        private auth: AuthService,
        private http: HttpClient,
        private readonly translateService: TranslateService
    ) {}

    get entity(): BulkExportMetaData {
        return this._entity;
    }

    set entity(value: BulkExportMetaData) {
        this._entity = value;
    }

    async export(): Promise<void> {
        const endpoint = this.getFileEndpoint();
        return this.http
            .get(endpoint, { responseType: 'blob' })
            .toPromise()
            .then((reportExport) => {
                const entityName = this.translateService.instant(this.entity.name).toLowerCase();
                const filename = `${entityName}_export.xlsx`;
                saveAs(reportExport, filename);
            });
    }

    private getFileEndpoint(): string {
        return (
            environment.api +
            '/v2/' +
            this.entity.exportModel['_resource'].replace(':company', String(this.auth.company.id))
        );
    }
}
